import React from 'react'
import { graphql, useStaticQuery } from "gatsby"
import { Bar } from 'react-chartjs-2'
import graphql2chartjs from 'graphql2chartjs'

import { colors } from './ChartUtils'

export const query = graphql`
  {
    bd: allBdmensualCsv(
        sort: {fields: Entidad}
    ) {
        TiendasYOcio: nodes {
            label: Mes
            data: Tiendas_y_Ocio
            filter: Entidad
        }    
        SupermercadosYFarmacias: nodes {
            label: Mes
            data: Supermercados_y_Farmacias
            filter: Entidad
        }                      
        Parques: nodes {
            label: Mes
            data: Parques
            filter: Entidad
        }    
        Transporte: nodes {
            label: Mes
            data: Transporte
            filter: Entidad
        }
        EspaciosDeTranajo: nodes {
            label: Mes
            data: Espacios_de_Trabajo
            filter: Entidad
        }    
    }
  }
`

const ChartMensualXEntidad = (props) => {
    const data = useStaticQuery(query)    
    const { bd: entries} = data

    let colorXdataset = {} // assign colors for each dataset
    let filteredEntries = {...entries}; // clone original object 
    let i = 0;
    Object.keys(entries).forEach(dataSetName => {
        filteredEntries[dataSetName] = entries[dataSetName].filter(e => e['filter']==props.entidad);
        colorXdataset[dataSetName] = colors[i];
        i++;
    });

    let chartTypeVar = ['bar', 'line'].includes(props.chartType) ? props.chartType : 'bar';

    // -------------------------
    const g2c = new graphql2chartjs();
    // add graphql data to graphql2chartjs instance while adding different chart types and properties
    g2c.add(filteredEntries, (dataSetName, dataPoint) => {
        return {
            ...dataPoint,
            chartType: chartTypeVar,
            borderColor: colorXdataset[dataSetName],
            pointBackgroundColor: colorXdataset[dataSetName],
            backgroundColor: colorXdataset[dataSetName],            
            fill: false
        }
    });    
    // ----------
    

    return(
        <div className="rpt-chart">            
            <h4>{props.entidad}</h4>
            {/* <Bar data={g2c.data} /> */}


            <Bar data={g2c.data} options={{ legend: {position: 'top'} 

                ,tooltips: {
                    callbacks: {
                        label: function(tooltipItem, data) {
                            var label = data.datasets[tooltipItem.datasetIndex].label || '';
                            if (label) {label += ': ';}
                            label += tooltipItem.yLabel.toFixed(2)
                            return label;
                        }
                    }
                }

            }}/>

        </div>
    )

}

// export default withChartUtils( ChartMensualXEntidad )
export default  ChartMensualXEntidad 